import { render, staticRenderFns } from "./DecompositionDetails.vue?vue&type=template&id=63412cdb"
import script from "./DecompositionDetails.vue?vue&type=script&lang=js"
export * from "./DecompositionDetails.vue?vue&type=script&lang=js"
import style0 from "./DecompositionDetails.vue?vue&type=style&index=0&id=63412cdb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports